/* eslint-disable @typescript-eslint/no-explicit-any */
import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import ReactMarkdown from 'react-markdown'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { Translation } from '../../contexts/TranslationContext'
import type { ContentTextBlockResult } from '../../data/ContentTextFragment'
import { ContentText } from '../content/ContentText'
import { CustomTooltip } from './CustomTooltip'
import style from './SummaryArticle.module.sass'

type SummaryArticleProps = {
	production?: string
	isDiet: boolean
	veterinaryDietNote?: string
	size: JSX.Element | undefined
	firstFiveItems?: any
	ingredientCategories?: JSX.Element[] | undefined
	vetDietInfo: ContentTextBlockResult[] | undefined
}

export const SummaryArticle: FunctionComponent<SummaryArticleProps> = ({
	production,
	isDiet,
	size,
	firstFiveItems,
	ingredientCategories,
	vetDietInfo,
}) => {
	const { width } = useWindowDimensions()
	const isMobile = Number(width) <= 768
	return (
		<div className={style.wrapper}>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="summaryArticle.production.title" />
				</div>
				<div className={clsx(style.value, !Boolean(production) && style.italic)}>
					{production || <Translation tr="summaryArticle.notSpecified" />}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="summaryArticle.diet.title" />
				</div>
				<div className={clsx(style.value, style.valueTooltip)}>
					{isDiet ? (
						<>
							<span className={style.redColor}>
								<Translation tr="summaryArticle.diet.veterinary" />
							</span>
							{vetDietInfo && (
								<>
									<span
										className={style.infoIcon}
										data-tooltip-id={isMobile ? `tooltipVetDietMobile` : 'tooltipVetDiet'}
										data-tip
									>
										i
									</span>
									<CustomTooltip
										tooltipId={isMobile ? `tooltipVetDietMobile` : 'tooltipVetDiet'}
										textAfterHover={
											<div className={style.tooltipDiet}>
												<ContentText blocks={vetDietInfo} />
											</div>
										}
									/>
								</>
							)}
						</>
					) : (
						<span>
							<Translation tr="summaryArticle.diet.regular" />
						</span>
					)}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="summaryArticle.foodSize.title" />
				</div>
				<div className={clsx(style.value, !Boolean(size) && style.italic)}>
					{size || <Translation tr="summaryArticle.notSpecified" />}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="summaryArticle.firstFiveItems.title" />
				</div>
				<div className={clsx(style.value, !Boolean(firstFiveItems) && style.italic)}>
					<ReactMarkdown linkTarget="_blank">{firstFiveItems}</ReactMarkdown>
					{/* (
						<Translation tr="summaryArticle.notSpecified" />
					) */}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="summaryArticle.categories.title" />
				</div>
				<div className={clsx(style.value, !Boolean(ingredientCategories) && style.italic)}>
					{ingredientCategories || <Translation tr="summaryArticle.notSpecified" />}
				</div>
			</div>
		</div>
	)
}
